<template>
  <div class="app-container">
    <div class="rp-toolbar">
      <div class="rp-title">角色权限配置</div>
      <el-button type="primary" :loading="saving" @click="handleSave">保存变更</el-button>
    </div>

    <el-table :data="permissions" v-loading="loading" row-key="id" size="small">
      <el-table-column prop="code" label="权限代码" width="220" />
      <el-table-column label="名称" width="180">
        <template slot-scope="{ row }">{{ displayPermissionName(row) }}</template>
      </el-table-column>
      <el-table-column
        prop="groupName"
        label="分组"
        width="120"
        :filters="groupFilters"
        :filter-method="filterGroup"
      >
        <template slot-scope="{ row }">
          <el-tag :type="row.groupName === 'agent' ? 'warning' : 'info'">{{ row.groupName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        v-for="role in roles"
        :key="role.role"
        :label="RoleNameMap[role.role] || ('角色 ' + role.role)"
        width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-checkbox
            :value="(editMap[role.role] || []).includes(row.code)"
            @change="(v) => toggle(role.role, row.code, !!v)"
          />
        </template>
      </el-table-column>
      <div slot="empty">暂无权限</div>
    </el-table>
  </div>
</template>

<script>
import { listPermissions, listRoles, updateRolePermissions } from '@/api/customerService/admin'

const RoleNameMap = {
  0: '客服',
  1: '主管',
  2: '管理员'
}

/** DB 若以错误编码写入会变成问号，此处补显示名 */
const PERMISSION_NAME_FALLBACK = {
  'agent:monitor': '旁听其他客服对话'
}

export default {
  name: 'RoleList',
  data () {
    return {
      RoleNameMap,
      permissions: [],
      roles: [],
      editMap: {},
      loading: false,
      saving: false
    }
  },
  computed: {
    groupFilters () {
      const set = new Set(this.permissions.map(p => p.groupName))
      return Array.from(set).map(g => ({ text: g, value: g }))
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    displayPermissionName (p) {
      const raw = (p.name || '').trim()
      const looksCorrupted = !raw || /^[?？\s\uFFFD]+$/.test(raw)
      if (looksCorrupted && PERMISSION_NAME_FALLBACK[p.code]) {
        return PERMISSION_NAME_FALLBACK[p.code]
      }
      return p.name || p.code
    },
    filterGroup (value, row) {
      return row.groupName === value
    },
    async loadData () {
      this.loading = true
      try {
        const [perms, rls] = await Promise.all([listPermissions(), listRoles()])
        this.permissions = perms.result || []
        this.roles = rls.result || []
        const map = {}
        this.roles.forEach(r => { map[r.role] = [...r.permissions] })
        this.editMap = map
      } catch (e) {
        this.$message.error('加载权限数据失败')
      }
      this.loading = false
    },
    toggle (role, code, checked) {
      const current = this.editMap[role] || []
      this.$set(this.editMap, role, checked ? [...current, code] : current.filter(c => c !== code))
    },
    async handleSave () {
      this.saving = true
      try {
        for (const role of this.roles) {
          const newPerms = this.editMap[role.role] || []
          const oldPerms = role.permissions
          if (JSON.stringify([...newPerms].sort()) !== JSON.stringify([...oldPerms].sort())) {
            await updateRolePermissions(role.role, newPerms)
          }
        }
        this.$message.success('权限已更新')
        await this.loadData()
      } catch (e) {
        this.$message.error((e && e.message) || '保存失败')
      }
      this.saving = false
    }
  }
}
</script>

<style scoped>
.rp-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.rp-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
</style>